module.exports = __webpack_public_path__ + "static/media/ic_employee_white.248d9e96.svg";